import React, { Component } from "react";
import { Card, CardBody, FormText, Progress } from "reactstrap";
import moment from "moment";
import NotificationSystem from "react-notification-system";
import ReportsPanel from "./reports-panel";
import ReportsTable from "./reports-table";

import { apiActions } from "../../_actions";
import { appConstants } from "../../_constants";
import { appHelpers } from "../../_helpers";
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";
import ReportIcon from 'react-icons/lib/md/insert-chart';

//react-redux comm
import { connect } from "react-redux";
import {} from "../../_actions";

import ViewHeader from "./view-header";

// styling
import "./style.css";

const travelRoutes = [
  { label: "All", value: "" },
  { label: "International", value: "International" },
  { label: "Domestic", value: "Domestic" }
];

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class Reports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      travelRouteOptions: travelRoutes,
      selectValue: { label: "All", value: "All" },

      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [],
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux
      //Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true
      },
      manifestReports: false
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;

    //Get today's manifest reports
    this.search();
  }

  //update selected category
  updateTravelRouteValue = newValue => {
    this.setState({
      selectValue: newValue
    });
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded = this._notificationSystem.addNotification(
      notification
    );
  };

  search = () => {
    const { dispatch } = this.props;
    const { startDate, endDate, selectValue } = this.state;
    this.setState({ contentError: false });
    dispatch(apiActions.startRequest());

    let isLocal = "";
    let StartDate = moment(startDate).format("M/D/YYYY");
    let EndDate = moment(endDate).format("M/D/YYYY");

    if (!selectValue) {
      isLocal = "";
    } else if (selectValue.value === "International") {
      isLocal = "&islocal=false";
    } else if (selectValue.value === "Domestic") {
      isLocal = "&islocal=true";
    }

    let url =
      appConstants.PAS_URL +
      "/api/Report/AirlineBreakdown?startdate=" +
      StartDate +
      "&enddate=" +
      EndDate +
      isLocal;

    appHelpers
      .getRequest(url)
      .then(res => {
        this.setState({
          manifestReports: res.data.length > 0 ? res.data : false
        });
        dispatch(apiActions.endRequest());
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        dispatch(apiActions.endRequest());
        this.setState({ contentError: errorMessage });
      });
  };

  render() {
    const {
      travelRouteOptions,
      selectValue,
      contentError,
      manifestReports
    } = this.state;
    const { requesting, pageRequesting } = this.props;

    return (
      <div className="view">
        <ViewHeader />
        <ViewContent>
          <Card className="mb-4">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) &&
              !pageRequesting && (
                <Progress
                  striped
                  animated
                  color="success"
                  value={100}
                  className="mb-2"
                />
              )}
            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}

            {/*Display component content when Data is gotten from API*/}
            {!contentError &&
              !pageRequesting && (
                <CardBody>
                  <h6 className="mb-0 text-uppercase pull-left">
                    Reports Panel
                      {!pageRequesting &&
                      manifestReports && (
                          <FormText color="muted">
                              <ReportIcon size="18" color="#43a8df"/>&nbsp;{appHelpers.numberWithCommasOnly(manifestReports.length)} records
                          </FormText>
                      )}
                  </h6>

                  <div className="clearfix">&nbsp;</div>
                  <ReportsPanel
                    travelRoutes={travelRouteOptions}
                    selectedTravelRoute={selectValue}
                    onTravelRouteValueChange={this.updateTravelRouteValue}
                    onSearch={this.search}
                    startDateChange={startDate => this.setState({ startDate })}
                    endDateChange={endDate => this.setState({ endDate })}
                  />
                  {/* <hr /> */}

                  <CardBody>
                    {!pageRequesting &&
                      manifestReports && (
                        <ReportsTable data={manifestReports} />
                      )}

                    {!pageRequesting &&
                      !manifestReports && (
                        <PageEmptyContent message="No record found for your search!" />
                      )}
                  </CardBody>
                </CardBody>
              )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { loggingIn } = state.authentication;
  const { pageRequesting, requesting } = state.api;
  const { alert, manifestReports } = state;
  return {
    loggingIn,
    requesting,
    pageRequesting,
    alert,
    manifestReports
  };
}

export default connect(mapStateToProps)(Reports);



// WEBPACK FOOTER //
// ./src/views/reports/index.js